// Custo de uma cor é por tecido (Color.costByCloth: [{ cloth, costs }]), não um valor único pra
// cor inteira — a mesma cor pode custar diferente em tecidos diferentes. `clothId` null/undefined
// ou a string 'none' lê o balde "sem tecido" (cor ainda não associada a nenhum tecido).
function getCostForCloth(color, clothId) {
    const normalizedClothId = (!clothId || clothId === 'none') ? null : (clothId._id || clothId)
    const entries = color?.costByCloth || []
    const entry = entries.find((e) => {
        const entryClothId = e.cloth?._id || e.cloth || null
        return entryClothId === normalizedClothId
    })
    return entry ? (entry.costs || []) : []
}

export function colorHasAnyCost(color) {
    return (color?.costByCloth || []).some((e) => e.costs && e.costs.length > 0)
}

export default getCostForCloth
